// The registration endpoints refuse an address that belongs to a school signing
// its students in through an SSO provider.

export const CleverRequiredErrorMessage =
  "Can't create an account with that email. Sign in with Clever instead, or register with a different email address."
export const ClassLinkRequiredErrorMessage =
  "Can't create an account with that email. Sign in with ClassLink instead, or register with a different email address."
export const GoogleRequiredErrorMessage =
  "Can't create an account with that email. Sign in with Google instead, or register with a different email address."
export const EmailAlreadyExistsErrorMessage =
  'An account with this email already exists. If you don’t remember your password, try resetting it.'
export const UnexpectedErrorMessage = 'An unexpected error occurred, please try again later.'

type RegistrationError = Pick<Response, 'status' | 'text'> & { body: unknown }

export const registrationErrorMessage = async (err?: Partial<RegistrationError>): Promise<string> => {
  const status = err?.status
  if (status === 409) {
    return EmailAlreadyExistsErrorMessage
  }

  if (status !== 403 || !err?.body || !err.text) {
    return UnexpectedErrorMessage
  }

  const body = await err.text()
  if (body.includes('clever')) {
    return CleverRequiredErrorMessage
  }
  if (body.includes('ClassLink')) {
    return ClassLinkRequiredErrorMessage
  }
  if (body.includes('Google')) {
    return GoogleRequiredErrorMessage
  }

  return UnexpectedErrorMessage
}
